module.exports = __webpack_public_path__ + "static/media/liveNationIcon.352b0b1e.png";